"use strict";

import http from "@/http";

const getEvents = async (companyId = null) => {
  const params = companyId ? { company: companyId } : {};
  const response = await http.get("/calendar-events", { params });
  return response.data;
};

const createEvent = async event => {
  const response = await http.post("/calendar-events", { event });
  return response.data;
};

const updateEvent = async event => {
  const response = await http.put(`/calendar-events/${event._id}`, { event });
  return response.data;
};

const deleteEvent = async id => {
  const response = await http.delete(`/calendar-events/${id}`);
  return response.data;
};

export default { getEvents, createEvent, updateEvent, deleteEvent };
